import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import FloatingActions from "./components/FloatingActions";
import LanguageSync from "./components/LanguageSync";
import LoadingSpinner from "./components/LoadingSpinner";
import ScrollManager from "./components/ScrollManager";
import SEO from "./components/SEO";
import ProtectedRoute from "./components/ProtectedRoute";

const Home = lazy(() => import("./pages/Home"));
const InfraProjects = lazy(() => import("./pages/InfraProjects"));
const Trading = lazy(() => import("./pages/Trading"));
const Investment = lazy(() => import("./pages/Investment"));
const Physio = lazy(() => import("./pages/Physio"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Admin = lazy(() => import("./pages/Admin"));
const Login = lazy(() => import("./pages/Login"));

function RouteFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <LoadingSpinner label="Loading VIP Groups..." />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageSync />
      <ScrollManager />
      <SEO />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/infra-projects" element={<InfraProjects />} />
          <Route path="/trading" element={<Trading />} />
          <Route path="/physio" element={<Physio />} />
          <Route path="/investment" element={<Investment />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route path="/in-project" element={<Trading />} />
          <Route path="/physio-life" element={<Physio />} />
          <Route path="/investment-planner" element={<Investment />} />
        </Routes>
      </Suspense>
      <FloatingActions />
    </BrowserRouter>
  );
}

export default App;
